import "core-js/modules/es.array.push.js";
import { createNamespacedHelpers } from "vuex";
const userVuex = createNamespacedHelpers("user");
const walletVuex = createNamespacedHelpers("wallet");
export default {
  name: "m-transaction",
  inject: ["reload"],
  computed: {
    ...walletVuex.mapState(["isMobile", "netId", "isWallet"])
  },
  data() {
    return {
      tradeNewestList: [],
      intervalId: null,
      totalItems: 0,
      carousel: null,
      currentIndex: 0,
      itemWidth: 0,
      isFetching: false,
      // 防止重复请求
      resizeTimeout: null
    };
  },
  watch: {
    "tradeNewestList.length": {
      handler(len) {
        if (len >= 5) {
          this.$nextTick(() => {
            this.onClose();
            this.carouselFn(); // 重新初始化轮播
          });
        }
      }
    },

    netId: {
      async handler(id) {
        if (id) {
          this.onClose();
          await this.setTrade(); // 初始化数据
          // this.carouselFn(); // 初始化轮播
        }
      },

      deep: true,
      immediate: true
    },
    isMobile: {
      handler(newVal, oldVal) {
        if (oldVal !== null && newVal !== oldVal) {
          this.stopCarousel();
          this.updateItemWidth();
          this.resetCarousel();
          this.startCarousel();
        }
      },
      deep: true
    }
  },
  methods: {
    ...userVuex.mapActions(["getTradeNewest"]),
    // 初始化轮播
    carouselFn() {
      this.carousel = this.$refs.carouselRef;
      const items = this.$refs.itemRef;

      // 获取每个元素的宽度
      this.updateItemWidth();

      // 克隆子元素
      this.cloneItems();

      // 启动轮播
      this.startCarousel();

      // 绑定鼠标和窗口变化事件
      this.setupMouseEvents();
      this.setupResizeEvent();
    },
    // 更新元素宽度
    updateItemWidth() {
      try {
        const items = this.$refs.itemRef;
        const item = items[0];
        const item1 = items[1];
        this.totalItems = items.length;
        this.itemWidth = item.offsetWidth + (item1.offsetLeft - item.offsetWidth);
      } catch (err) {}
    },
    // 克隆子元素
    cloneItems() {
      const items = this.$refs.itemRef;
      for (let i = 0; i < Math.ceil(500 / this.itemWidth); i++) {
        const clone = items[i % items.length].cloneNode(true);
        this.carousel.appendChild(clone);
      }
    },
    // 启动轮播
    startCarousel() {
      this.stopCarousel(); // 确保定时器未重复
      this.intervalId = setInterval(async () => {
        this.currentIndex++;
        // 滚动
        this.carousel.style.transform = `translateX(-${this.currentIndex * this.itemWidth}px)`;
        // 无缝衔接逻辑
        if (this.currentIndex >= this.totalItems) {
          this.stopCarousel();
          await this.setTrade();
          this.resetCarousel();
          this.startCarousel();
        }
      }, 2000);
    },
    // 停止轮播
    stopCarousel() {
      if (this.intervalId) {
        clearInterval(this.intervalId);
        this.intervalId = null;
      }
    },
    // 鼠标事件绑定
    setupMouseEvents() {
      if (this.isMobile) {
        this.carousel.removeEventListener("mouseenter", this.stopCarousel); // 鼠标移入停止轮播
        this.carousel.removeEventListener("mouseleave", this.startCarousel); // 鼠标移开继续轮播
        return;
      }
      this.carousel.addEventListener("mouseenter", this.stopCarousel); // 鼠标移入停止轮播
      this.carousel.addEventListener("mouseleave", this.startCarousel); // 鼠标移开继续轮播
    },

    // 窗口变化事件绑定
    setupResizeEvent() {
      // if (this.isMobile) {
      //   return;
      // }
      // window.addEventListener("resize", this.onResize);
    },
    // 窗口大小变化处理
    onResize() {
      clearTimeout(this.resizeTimeout);
      this.resizeTimeout = setTimeout(() => {
        this.stopCarousel();
        this.updateItemWidth();
        this.resetCarousel();
        this.startCarousel();
      }, 2000);
    },
    // 重置轮播位置
    resetCarousel() {
      this.carousel.style.transition = "none";
      this.currentIndex = 0;
      this.carousel.style.transform = `translateX(0)`;

      // 恢复过渡效果
      this.$nextTick(() => {
        setTimeout(() => {
          this.carousel.style.transition = "transform 0.5s ease";
        }, 50);
      });
    },
    // 拉取新数据
    async setTrade() {
      if (this.isFetching) return; // 防止重复请求
      this.isFetching = true;
      const res = await this.getTradeNewest();
      if (!res) {
        this.isFetching = false;
        return;
      }

      // 更新数据
      this.tradeNewestList = res;
      this.isFetching = false;
    },
    // 销毁事件
    onClose() {
      this.stopCarousel();
      if (this.carousel) {
        this.carousel.removeEventListener("mouseenter", this.stopCarousel);
        this.carousel.removeEventListener("mouseleave", this.startCarousel);
      }
      window.removeEventListener("resize", this.onResize);
    },
    onSkip(item) {
      if (this.$route.name === "token-id") {
        this.$router.push(`/token/${item.address}`);
        this.reload();
      } else {
        this.$router.push(`/token/${item.address}`);
      }
    }
  },
  beforeDestroy() {
    this.onClose();
  }
};